import { Children } from "react";
import SearchableSelect from "./SearchableSelect";

// Keep filter values as strings for single selection and arrays for multiple selection.
export default function QuestionFilterSelect({ children, onChange, ...props }) {
  const fieldName = String(props["aria-label"] || "篩選").replace(
    /^(講義挑題|重複檢查|查詢|挑題|講義|考卷|紀錄)/, "",
  );
  const options = Children.toArray(children).map((child) => ({
    value: String(child.props.value),
    label: Children.toArray(child.props.children).join(""),
  }));
  return <SearchableSelect {...props} allowMultiple options={options}
    placeholder={fieldName} placeholderValues={["", "__none__"]}
    exclusiveValues={["", "__none__", "__all__", "all"]}
    onChange={(value) => onChange({ target: { value } })} />;
}
